import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useTranslation, withTranslation } from 'react-i18next'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import AccessControl from '@modules/auth/AccessControl'
import { Link } from 'react-router-dom'
import history from '@services/History'
import Consultations from '@services/Consultations'
import Loading from '@modules/core/components/Loading'
import styled from 'styled-components'
import CustomPagination from '@modules/tableComponents/Pagination'
import { getNameSpecialityFromType } from '@modules/admin/speciality/actions'

const SpecialitiesIndex = () => {
  const [specialities, setSpecialities] = useState([])
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState({
    page: 1,
    lastPage: 1,
  })
  const { t } = useTranslation()

  const fetchSpecialities = async (page) => {
    setLoading(true)
    try {
      const { data, meta } = await Consultations.speciality.index({ page, per_page: 25 })
      setPagination({ page: meta?.current_page, lastPage: meta?.last_page })
      setSpecialities(data)
    } catch (e) {
      console.error(e.message)
    }
    setLoading(false)
  }
  useEffect(() => {
    fetchSpecialities()
  }, [])
  let component
  if (loading) component = <Loading isFetching={true} />
  else {
    if (!!specialities.length)
      component = (
        <>
          <Table>
            <thead>
              <tr>
                <td>{t('Icono')}</td>
                <td>{t('Nombre')}</td>
                <td>{t('Código')}</td>
                <td>{t('Tipo')}</td>
                <th className="actions-col">{t('Acciones')}</th>
              </tr>
            </thead>
            <tbody>
              {specialities.map((speciality) => (
                <tr key={speciality.id}>
                  <td>{speciality.icon && <IconStyle src={speciality.icon} alt="icon" />}</td>
                  <td>
                    {speciality.translations.map((trans) => (
                      <div>{`${trans.locale}: ${trans.name}`}</div>
                    ))}
                  </td>
                  <td>{speciality.code}</td>
                  <td>{getNameSpecialityFromType(speciality.type)}</td>
                  <td>
                    <div className="actions-container">
                      <span
                        onClick={() => history.push(`speciality/update/${speciality.id}`)}
                        className="far fa-edit"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CustomPagination
            onClickItem={(page) => fetchSpecialities(page)}
            activePage={pagination.page}
            totalPages={pagination.lastPage}
            maxButtons={7}
          />
        </>
      )
    else component = <div>no hay elementos</div>
  }
  return (
    <div>
      <DashboardHeader title={t('Especialidades')} total={specialities && specialities.length}>
        <AccessControl>
          <Link to={`speciality/create`} className="btn btn-primary">
            {t('Crear')}
          </Link>
        </AccessControl>
      </DashboardHeader>
      {component}
    </div>
  )
}

export default withTranslation()(SpecialitiesIndex)

const IconStyle = styled.img`
  background-color: #01a8e7;
  height: 24px;
  width: 24px;
  border-radius: 6px;
  padding: 3px;
  object-fit: contain;
`
